<template>
  <Modal
    :value="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="420"
    class-name="coupon-add-quota-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">追加发放量</span>
    </div>

    <div class="modal-body">
      <Input
        v-model="add_count"
        type="number"
        placeholder="请输入要追加的券发放数量"
        :max-length="10"
      />
      <div class="quota-row">
        <span class="label">原有发放量：</span>
        <span class="value">{{ coupon ? coupon.release_num : 0 }}</span>
      </div>
      <div class="quota-row">
        <span class="label">现有库存量：</span>
        <span class="value">{{ stockCount }}</span>
      </div>
    </div>

    <div class="modal-footer">
      <div class="btn cancel" @click="onCancel">取消</div>
      <div class="btn confirm" :class="{ disabled: !add_count || Number(add_count) <= 0 }" @click="onConfirm">确认追加</div>
    </div>
  </Modal>
</template>

<script>
// 追加发放量弹窗（纯静态交互，接口联调由父组件 confirm 回调处理）
export default {
  name: "CouponAddQuotaModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 当前操作的优惠券行数据
    coupon: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      add_count: "",
    };
  },
  computed: {
    // 现有库存量 = 原有发放量 - 已领取量
    // TODO 接口联调：如接口直接返回库存量字段，替换此处计算
    stockCount() {
      if (!this.coupon) return 0;
      return Math.max(this.coupon.release_num - this.coupon.take_num, 0);
    },
  },
  methods: {
    onVisibleChange(val) {
      if (val) {
        this.add_count = "";
      } else {
        this.onCancel();
      }
    },
    onCancel() {
      this.$emit("update:visible", false);
    },
    onConfirm() {
      const count = Number(this.add_count);
      if (!count || count <= 0) return;
      this.$emit("confirm", {
        id: this.coupon && this.coupon.id,
        add_count: count,
      });
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .coupon-add-quota-modal {
  text-align: left;
  line-height: 1.5;
  .ivu-modal-content {
    border-radius: 10px;
  }

  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-close {
    top: 14px;
    right: 14px;
  }
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 38px 24px 0 24px;
  // border-bottom: 1px solid #f0f0f0;
  position: relative;

  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
}

.modal-body {
  padding: 12px 24px 24px 24px;

  .quota-row {
    margin-top: 8px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 24px;
    }

    .label {
      font-size: 14px;
      color: #999999;
    }

    .value {
      font-size: 14px;
      color: #666666;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 24px 24px;

  .btn {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #666666;
      font-weight: bold;

      &:hover {
        border-color: #cccccc;
      }
    }

    &.confirm {
      width: 120px;
      background: #ff5967;
      color: #ffffff;
      font-weight: bold;

      &:hover {
        opacity: 0.9;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>
